// extracted by mini-css-extract-plugin
export default {"footer":"Landscape_footer__yKuEs","wrapper":"Landscape_wrapper__J1TsM","logoFt":"Landscape_logoFt__iUIxd","linkView":"Landscape_linkView__hQfmV"};